import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatNativeDateModule } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { RrulePipe } from '@modules/elements/pipes/rrule.pipe';
import { DifferencePipe } from '@modules/elements/pipes/difference.pipe';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from '@modules/auth/interceptors/auth.interceptor';
import { errorInterceptor } from '@modules/auth/interceptors/error.interceptor';
import { provideToastr } from 'ngx-toastr';
import { TimeFormatPipe } from '@modules/elements/pipes/time-format.pipe';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        errorInterceptor
      ])
    ),
    importProvidersFrom(MatNativeDateModule),
    provideToastr(),
    DatePipe,
    RrulePipe,
    TimeFormatPipe,
    DifferencePipe,
  ]
};
